// src/components/facilitymanager/FacilityManagerRoute.js
import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../common/Spinner";

// Same shape as AdminRoute, but for userType === "facilityManager" — its
// own standalone role, not a cut-down Admin. A facility manager who lands
// on /admin/* gets bounced here too (see the userType check in AdminRoute
// not matching), and vice versa: an admin visiting /facility-manager/*
// gets redirected to login just like anyone else who isn't a facility
// manager. The two roles don't share a panel.
const FacilityManagerRoute = () => {
  const auth = useSelector((s) => s.auth);
  const location = useLocation();

  const authChecked = !!auth.authChecked;
  const isAuthenticated = !!auth.isAuthenticated;
  const user = auth.user || {};

  // See authChecked in reducers/authReducer.js / PrivateRoute.js.
  if (!authChecked) return <Loader />;

  const isFacilityManager = isAuthenticated === true && user.userType === "facilityManager";
  if (!isFacilityManager) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default FacilityManagerRoute;